import React from "react";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import styles from "./CustomCheckbox.module.css";

const CustomCheckbox = ({
  label,
  name,
  checked = false,
  onChange,
  onBlur,
  disabled = false,
  required = false,
  indeterminate = false,
  error,
  helperText,
  className = "",
  labelClassName = "",
  size = "md",
  ...rest
}) => {
  const sizeMap = {
    sm: "small",
    md: "medium",
    lg: "medium",
  };

  return (
    <div className={`${styles.wrapper} ${className}`}>
      <FormControlLabel
        className={`${styles.formControl} ${styles[size]}`}
        control={
          <Checkbox
            name={name}
            checked={checked}
            indeterminate={indeterminate}
            onChange={onChange}
            onBlur={onBlur}
            disabled={disabled}
            size={sizeMap[size]}
            className={styles.checkbox}
            sx={{
              color: error ? "var(--color-danger)" : "var(--color-border)",
              "&.Mui-checked": {
                color: "var(--color-primary)",
              },
              "&.MuiCheckbox-indeterminate": {
                color: "var(--color-primary)",
              },
            }}
            {...rest}
          />
        }
        label={
          label ? (
            <span
              className={`${styles.label} ${labelClassName} ${
                disabled ? styles.labelDisabled : ""
              }`}
            >
              {label}
              {required && <span className={styles.required}>*</span>}
            </span>
          ) : null
        }
      />
      {(error || helperText) && (
        <span
          className={`${styles.helperText} ${error ? styles.errorText : ""}`}
        >
          {error || helperText}
        </span>
      )}
    </div>
  );
};

export default CustomCheckbox;
